<!--This component is created to transfer data from screencreator to trnxmasterscreen.-->
<div class="topDiv" style="margin-top:10%;margin-left:5%">

    <div class="divStyle">
    
        Please do not click on migration button.

    </div>

    <button (click)="migrateJsons()">Migration</button>

</div>